export default __webpack_public_path__ + "static/media/spotify.581e55fe.png";